export const FIELDS_FRAMES = {
  adminId: "Admin Id",
  name: "Name",
  price: "Price",
  color: "Color",
  rgb: "Rgb",
  frameHeight: "Frame height",
  frameWidth: "Frame width",
  rabbetDepth: "Rabbet depth",
  rabbetWidth: "Rabbet width",
  pieceLength: "Piece length",
  imageUrl: "Image url",
  isInStock: "Is in stock",
};

export const DEFAULT_FIELD_CREATE = {
  adminId: "",
  color: "",
  frameHeight: "",
  frameWidth: "",
  imageUrl: "",
  name: "",
  oversizedMattColor: false,
  pieceLength: "",
  price: "",
  rabbetDepth: "",
  rabbetWidth: "",
  rgb: "",
  type: "frame",
};



// WEBPACK FOOTER //
// ./src/constants/admin-fields.js